import { useTheme, useMediaQuery } from '@mui/system';
import { useState } from 'react';

const useReportInfoBlockLogic = () => {
	const theme = useTheme();
	const [isCollapsed, setIsCollapsed] = useState(false);
	const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
	const [isModalOpen, setIsModalOpen] = useState(false);

	const handleToggleCollapse = () => {
		if (!isDesktop) setIsCollapsed((collapse) => !collapse);
	};

	const handleModalOpen = (value: boolean) => () => {
		setIsModalOpen(value);
	};

	return {
		isCollapsed,
		isModalOpen,
		handleToggleCollapse,
		handleModalOpen,
	};
};

export default useReportInfoBlockLogic;
